import React from 'react'
import { 
  Redirect,
  Link
} from 'react-router-dom'
import { connect } from 'react-redux'
import { Form, Formik } from 'formik'
import * as yup from 'yup'
 
import { actions as authActions } from '@modules/auth'
import LayoutCentered from '@components/LayoutCentered/LayoutCentered'
import BrandLogo from '@components/BrandLogo/BrandLogo'
import PageHeader from '@components/PageHeader/PageHeader'
import AlertBox from '@components/AlertBox/AlertBox'
import { FieldGroup } from '@modules/form/form.module'
import { UserModel } from '@modules/user/user.module'

// import './ForgotPassword.scss'
 
// TODO: add prop types
// TODO: use react-form to do the forms

@LayoutCentered
class ForgotPassword extends React.Component {
 
  constructor(props) {
    super(props);
    this.state = { 
      message: '',
      success: false,
    }
  }

  static fields = [
    ['email', {
      autoFocus: true,
    }]
  ];
 
  render() {
    const { message, success } = this.state;
    const { fields } = this.constructor;
    return (
      <Formik
        validateOnBlur={false}
        initialValues={UserModel.getDefaults(fields)}
        onSubmit={async (values, actions) => {

          this.setState({ message: '', success: false });

          const res = await fetch('/api/forgot', {
            method: "POST",
            body: JSON.stringify(values),
            headers: {
              "Content-Type": "application/json",
            },
          })

          const body = await res.json();

          await this.setState({ success: res.ok, ...body });

          // console.log(res);
          actions.setSubmitting(false);
        }}
        validationSchema={UserModel.getValidationSchema(fields)}
      >
      {({ isSubmitting }) => (
        <div className="ForgotPassword">
          <BrandLogo />
          <h1>Forgot Password</h1>
          { !success && (
            <Form>
              <FieldGroup {...UserModel.getFieldProps('email')} autoFocus={true} />
              <button type="submit" disabled={isSubmitting}>Send reset link</button>
            </Form>
          )}
          {
            message
            && <AlertBox type={success ? 'normal' : 'error'}>{message}</AlertBox>
          }
          <Link to="/login">Back to login</Link>

        </div>
      )}
      </Formik>
    );
  }

}
 
export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/scenes/ForgotPassword/ForgotPassword.jsx